import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { InputAddressSelectorComponent } from './input-address-selector.component';

@NgModule({
  declarations: [InputAddressSelectorComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [InputAddressSelectorComponent],
})
export class InputAddressSelectorModule {}
